import { useDealer } from "src/hooks/useDealer";
import { useDealerUserInfo } from "src/context/DealerUserInfoContext";
import { useValidateDealerId } from "src/hooks/useValidateDealerId";
import { usePageView } from "src/hooks/usePageView";
import { useDgaModal } from "src/context/DgaModalContext";
import QaBanner from "src/components/QaBanner";
import { useQaView } from "src/hooks/useQaView";
import LeftDrawer from "./LeftDrawer";
import MainPane from "./MainPane";
import { HEADER_HEIGHT } from "src/constants";

export default ({
  page,
  title,
  children,
  showHeading = true,
  totalCount,
  header,
  leftContent,
  hasBorder = true,
  headerAction,
}: {
  page: string;
  title?: string;
  children: React.ReactNode;
  showHeading?: boolean;
  totalCount?: number;
  header?: React.ReactNode;
  leftContent?: React.ReactNode;
  hasBorder?: boolean;
  headerAction?: React.ReactNode;
}) => {
  const { dealerUserInfo, isLoading } = useDealerUserInfo();
  const { dealer_id } = useDealer();
  const { openDgaModal } = useDgaModal();
  const { enabled: qaViewEnabled } = useQaView();
  const showNewApplication = page === "applications" || page === "dashboard";
  const showHeader = header || qaViewEnabled;
  const headerHeightValue =
    header && qaViewEnabled ? HEADER_HEIGHT * 2 : HEADER_HEIGHT;
  usePageView(page, title);
  useValidateDealerId();

  let headerTitleText = `Hello, ${dealerUserInfo.first_name ?? ""}!`;
  let headerSubTitleText = "Here's a snapshot of how your dealer is doing.";
  if (page === "applications") {
    headerTitleText = "Applications";
    headerSubTitleText = "View and manage applications";
  } else if (page === "employees") {
    headerTitleText = "Employees";
    headerSubTitleText = "View and manage employees";
  } else if (page === "dealers") {
    headerTitleText = "Dealers";
    headerSubTitleText = "View and manage dealers";
  } else if (page === "resources") {
    headerTitleText = "Resources";
    headerSubTitleText =
      "PorchPass and Dealer specific documents, tools, and other resources.";
  }

  return (
    <div className="flex overflow-hidden flex-col h-screen">
      {showHeader && (
        <div
          className={`relative w-full flex items-center justify-between border-b border-[rgba(228,231,236,1)] ${
            headerHeightValue > HEADER_HEIGHT ? "flex-col" : "flex-row"
          }`}
        >
          {qaViewEnabled && <QaBanner />}
          {header}
        </div>
      )}

      <div className="flex overflow-hidden flex-row flex-1">
        <div
          className={`relative ${leftContent ? "w-[360px]" : "w-[272px]"} pr-[23px] flex flex-col ${
            hasBorder ? "border-r border-[rgba(228,231,236,1)]" : ""
          }`}
        >
          {leftContent ?? (
            <LeftDrawer
              page={page}
              userInfo={dealerUserInfo}
              dealer_id={dealer_id || ""}
            />
          )}
        </div>
        <div className="overflow-y-auto flex-1">
          <MainPane
            showHeading={showHeading}
            page={page}
            headerTitleText={headerTitleText}
            totalCount={totalCount}
            headerSubTitleText={headerSubTitleText}
            showNewApplication={showNewApplication}
            onNewApplication={() => openDgaModal()}
            headerAction={headerAction}
            isLoading={isLoading}
          >
            {children}
          </MainPane>
        </div>
      </div>
    </div>
  );
};
